document.addEventListener('DOMContentLoaded', function() {

    // Header search
    var search_icons = document.querySelectorAll('header .icon.search');
    var search_form = document.querySelector('header form.search');
    if (search_icons.length && search_form) {
      search_icons.forEach((search_icon) => {
        search_icon.addEventListener('click', function(e) {
          e.preventDefault();
          search_form.classList.toggle('active');
          if (search_form.classList.contains('active')) {
            var search_input = search_form.querySelector('.search__input.field__input');
            if (search_input) search_input.focus();
          }
        })
      });
    }

    // home slider
    if (document.querySelector('.home-slider')) {

        if (window.innerWidth <= 960) {
            var removeSlides = document.querySelectorAll('.swiper-slide:empty');
            removeSlides.forEach(removeSlide => {
                removeSlide.remove();
            });
        }

        const swiper = new Swiper('.home-slider.swiper', {
            pagination: false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            autoHeight: true,
            scrollbar: false,
            slidesPerView: 3,
            initialSlide: 0,
            breakpoints: {
                300: {
                    slidesPerView: 1,
                },
                960: {
                    slidesPerView: 3
                }
            }
        });

        if (document.querySelector('.creations-swiper')) {
            new Swiper('.creations-swiper', {
                navigation: {
                    nextEl: '.creations-swiper .swiper-button-next',
                    prevEl: '.creations-swiper .swiper-button-prev',
                },
                slidesPerView: 6,
                slidesPerGroup: 6,
            });
        }
    }

    // product gallery
    var main_thumb = document.querySelector('.product__media-wrapper .product__media-item:first-child img');
    var thumbs = document.querySelectorAll('.product__media-wrapper .product__media-item:not(:first-child) img');
    if (window.innerWidth > 960 && thumbs.length) {
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', function(e) {
          e.preventDefault();
          var this_img = e.target.dataset.image;
          if (main_thumb.srcset == this_img) {
            this_img = main_thumb.dataset.image;
          }
          main_thumb.srcset = this_img;
          main_thumb.src = this_img;
        })
      });
    }

    // check home large text is > 50% in viewport
    var textFade = document.querySelector('.text-fade');
    if (textFade) {
        window.addEventListener('scroll', function() {
            const rect = textFade.getBoundingClientRect();
            if (window.innerHeight * 0.5 - rect.y) {
                textFade.classList.add('visible');
            }
        })
    }

    // mobile menu
    var mobile_toggle = document.querySelector('.toggle-menu');
    if (mobile_toggle) {
        var mobile_close = document.querySelector('.mobile-close');
        mobile_toggle.addEventListener('click', function(e) {
            e.preventDefault();
            document.body.classList.toggle('mobile-show')
        });
        if (mobile_close) {
          mobile_close.addEventListener('click', function(e) {
            e.preventDefault();
            document.body.classList.remove('mobile-show')
          })
        }
    }
});